<template>
  <div class="addvip">
   <div class="content">
      <!-- 标题 -->
    <div class="title">
      <i class="el-icon-edit"></i>
      <span>修改道馆信息</span>

      <!-- 返回按钮 -->
      <div class="back">
        <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
      </div>
    </div>
    

    <!-- 表单内容 -->
    <el-form :model="form" class="main" size="medium" status-icon label-width="120px" ref="ruleForm">
      <!--<el-form-item label="场地名称:" prop="name" :rules="{ required: true, message: '标题不能为空', trigger: ['blur','change']}" >-->
      <!--  <el-input v-model="form.name" placeholder="请输入标题"></el-input>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="道馆人数:" prop="price" :rules="{ required: true, message: '预约价格不能为空', trigger: ['blur','change']}" >-->
      <!--  <el-input v-model="form.price" placeholder="请输入道馆人数"></el-input>-->
      <!--</el-form-item>-->
      <!--<el-form-item label="道馆地址:" prop="info" :rules="{ required: true, message: '内容不能为空', trigger: ['blur','change']}">-->
      <!--  <el-input v-model="form.info" placeholder="请输入道馆地址" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item prop="district" label="所属地区" :rules="{ required: true, message: '所属地区不能为空', trigger: ['blur','change']}"><el-input v-model="form.district" placeholder="请输入所属地区"></el-input>
              
          </el-form-item>
          <el-form-item prop="info" label="单位简介" :rules="{ required: true, message: '单位简介不能为空', trigger: ['blur','change']}"><el-input v-model="form.info" placeholder="请输入单位简介"></el-input>
              
          </el-form-item>
          <el-form-item prop="address" label="地址" :rules="{ required: true, message: '地址不能为空', trigger: ['blur','change']}"><el-input v-model="form.address" placeholder="请输入地址"></el-input>
              
          </el-form-item>
          <el-form-item prop="ownerName" label="负责人" :rules="{ required: true, message: '负责人不能为空', trigger: ['blur','change']}"><el-input v-model="form.ownerName" placeholder="请输入负责人"></el-input>
              
          </el-form-item>
          <el-form-item prop="tel" label="联系电话" :rules="{ required: true, message: '联系电话不能为空', trigger: ['blur','change']}"><el-input v-model="form.tel" placeholder="请输入联系电话"></el-input>
              
          </el-form-item>
          <el-form-item prop="no" label="团体会员编号" :rules="{ required: true, message: '会员编号不能为空', trigger: ['blur','change']}"><el-input v-model="form.no" placeholder="请输入团体会员编号"></el-input>
              
          </el-form-item>
          <el-form-item prop="certNum" label="证照编号" :rules="{ required: true, message: '证照编号不能为空', trigger: ['blur','change']}"><el-input v-model="form.certNum" placeholder="请输入证照编号"></el-input>
              
          </el-form-item>
          <el-form-item prop="endDate" label="到期时间" :rules="{ required: true, message: '到期时间不能为空', trigger: ['blur','change']}"><el-input v-model="form.endDate" placeholder="请输入到期时间"></el-input>
              
          </el-form-item>
      <el-form-item label="团体证件:" prop="link">
          <el-upload
            name="file"
            class="avatar-uploader"
            action=''
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            :http-request="uploadFile"
          >
            <img v-if="form.img" :src="this.$store.state.ip+this.form.img" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

      <el-form-item class="control">
        <el-button type="danger" icon="el-icon-close" @click="back">取消</el-button>
        <el-button @click="resetForm('ruleForm')" class="reset-btn" icon="el-icon-refresh-left">重置</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-document-add">保存</el-button>
      </el-form-item>

      
    </el-form>
   </div>
  </div>
</template>
<script>
 export default {
    data() {
      return {
        file:{},
        form:{},
        data:{},
      }
    },
    methods: {
      //返回房产信息列表
      back(){
        this.$router.push({path:'/home/place'});
      },

      // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      handleChange(file) {
        this.file = file.raw
        console.log(this.file);
      },

      // 上传文件之前的钩子
      beforeUpload(file) {
        console.log("上传前");
        const isJPG = file.type ==="image/jpeg"||"image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("上传头像图片只能是JPG 或png格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },

      // 自定义图片上传
      uploadFile() {
        // 创建表单对象
        let form = new FormData();
        // 后端接受参数 ，可以接受多个参数
        form.append("file",this.file)

        // 请求头设置文件上传
        let config = {
            //必须
          headers: {
              "Content-Type": "multipart/form-data"
          },
        }
        // 发送请求
        this.axios.post('/teacher/upload',form,config)
        .then(res=>{
          console.log(res.data)
          if(res.data.code=='200'){
            this.form.img = res.data.url;
          }
        })
        .catch(err=>{
          this.$message.error(err);
        })
      },
     switchTimeFormat(date) {
      var dateTime = new Date(date);
      var month = dateTime.getMonth() + 1;
      var day = dateTime.getDate();
      var hour = dateTime.getHours();
      month = month>9?month:'0'+month;
      day = day>9?day:'0'+day;
      hour = hour>9?hour:'0'+hour;
      var time  = month+"月"+day+"日 "+hour+":00-"+hour+":50"
      return time;
    },

      // 格式化数据
      formateData(item){
      var data={};
      data.img=item.p_img;
      data.id=item.p_id;
      data.tel=item.p_tel,
      data.no=item.p_Num,
      data.endDate=this.switchTimeFormat(item.end_time),
      data.district=item.p_district,
      data.info=item.p_info,
      data.ownerName=item.p_ownerName,
      data.address=item.p_address,
      data.certNum=item.p_cert,
      data.operater=item.operater
        return data;
      },

      // 提交表单
      submitForm(formName) {
        this.form.operater=sessionStorage.getItem("tel");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm("此操作会将数据永久性修改，确认是否继续操作?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(()=>{
              console.log("seccess!",this.form);
              this.axios.post("/place/alter",{
              id:this.form.id,
              tel:this.form.tel,
              no:this.form.no,
              endDate:this.form.endDate,
              district:this.form.district,
              info:this.form.info,
              ownerName:this.form.ownerName,
              address:this.form.address,
              img:this.form.img,
              certNum:this.form.certNum,
              operater:this.form.operater
              })
              .then(res=>{
                console.log(res);
                if(res.data.code=='200'){
                  this.$message.success(res.data.msg);
                  this.$router.push({path:'/home/place'});
                }
              })
              .catch(err=>{
                this.$message.error(err);
              })
            })
            .catch(()=>{
              this.$message.info("已取消修改");
            })
            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },

      // 重置表单
      resetForm() {
        this.form=this.formateData(this.data);
      },

    },
    mounted() {//创建时获取数据
      this.axios.post('/place/getDetail',{
        id:this.$route.params.id
      })
      .then(res=>{
        console.log(res.data)
        if(res.data.code=='200'){
          this.data = res.data.data;
          this.form=this.formateData(res.data.data)
        }
      });
    },
  }
</script>
<style lang="less">
@import "../assets/less/base.less";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: @greenColor;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style lang="less" scoped>
@import "../assets/less/base.less";
.addvip {
  color: @fontColor;
  background-color: white;
  min-height: 500px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.el-input--medium,.el-select,.time-input{
  width: 300px;
}
.reset-btn{
  background: @blueGreenColor;
  color: white;
  border-color: @blueGreenColor;
}
.el-form--inline .control{
  text-align: right;
  width: 100%;
}
</style>